import DeleteDialog from './components/DeleteDialog'

const DeleteWebhookModal = ({ open, onClose, onDelete }) => {
  return (
    <DeleteDialog
      handleDeleteUser={onDelete}
      open={open}
      onClose={onClose}
      header='Confirmation'
      title='Deleting this webhook will  delete any existing data related to webhook.'
      subtitle='This action cannot be undone'
    />
  )
}

export default DeleteWebhookModal
